import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const RadioButton = ({ selectedValue, reason, reasonText, onChange}) => (
    <label className="block-reason-radio fake-radio-green radio-text">
        {reasonText}
        <input type="radio"
            onChange={onChange}
            checked={selectedValue === reason}
            value={reason}/>
        <span className="radio-img"></span>
    </label>
);

RadioButton.PropTypes = {
    selectedValue: PropTypes.string,
    reasonText: PropTypes.string,
    onChange: PropTypes.func,
    reason: PropTypes.string
};

RadioButton.defaultProps = {
    selectedValue: '',
    reasonText: '',
    reason: ''
};

export default RadioButton;


// WEBPACK FOOTER //
// ./src/components/block_user/ModalWrapper/ModalBody/RadioButton/index.js